/*!
 * Tech2000s Currency Converter (v2)
 * Client-side only. Uses Shopify's own public endpoints:
 *   - /browsing_context_suggestions.json  (geo-IP country)
 *   - https://cdn.shopify.com/s/javascripts/currencies.js  (daily FX; rates[X] = USD value of 1 X)
 *
 * window.CurrencyConverter = { get, set, open, convert, format, rates, ready }
 *
 * Rules:
 *  - When the shopper views in the store's checkout currency, NOTHING on the page is touched.
 *  - Only real money strings in the store's own format ("R 49.99", "R 49.99 ZAR") are converted,
 *    never other numbers ("30-day", "3DS", "2000s").
 *  - Converted (display-only) prices: keep the integer part, force .99. Zero-decimal currencies stay whole.
 *  - The "you'll be charged" amount is never rounded.
 */
(function (window, document) {
  'use strict';
  if (window.CurrencyConverter) return;

  var cfg = window.__cc_config || {};
  var ACTIVE = String((window.Shopify && Shopify.currency && Shopify.currency.active) || cfg.activeCurrency || 'ZAR').toUpperCase();
  var MARKETS = cfg.marketsCurrencies || {};           // iso currency -> a country code that checks out in it
  var SAMPLE = cfg.moneySample || {};                   // rendered from 1234.56 with the shop's formats
  var LS_RATES = 'cc_rates_v2';
  var LS_CUR = 'cc_currency';
  var RATES_TTL = 12 * 60 * 60 * 1000;
  var GEO_TIMEOUT = 1200;

  var ZERO_DEC = { BIF:1, CLP:1, DJF:1, GNF:1, ISK:1, JPY:1, KMF:1, KRW:1, PYG:1, RWF:1, UGX:1, VND:1, VUV:1, XAF:1, XOF:1, XPF:1 };

  // Country -> currency (turns the geo-IP country into a currency)
  var EURO = 'AT BE CY DE EE ES FI FR GR HR IE IT LT LU LV MT NL PT SI SK AD MC SM VA ME XK';
  var COUNTRY_CUR = {
    US:'USD', CA:'CAD', MX:'MXN', BR:'BRL', AR:'ARS', CL:'CLP', CO:'COP', PE:'PEN', UY:'UYU', BO:'BOB',
    PY:'PYG', CR:'CRC', DO:'DOP', GT:'GTQ', JM:'JMD', TT:'TTD', PA:'PAB', HN:'HNL', NI:'NIO', BZ:'BZD',
    BS:'BSD', BB:'BBD', KY:'KYD', AW:'AWG', CW:'ANG', SR:'SRD', GY:'GYD', HT:'HTG', EC:'USD', SV:'USD', PR:'USD',
    GB:'GBP', IM:'GBP', JE:'GBP', GG:'GBP', CH:'CHF', LI:'CHF', SE:'SEK', NO:'NOK', DK:'DKK', IS:'ISK',
    PL:'PLN', CZ:'CZK', HU:'HUF', RO:'RON', BG:'BGN', RS:'RSD', MK:'MKD', AL:'ALL', BA:'BAM', MD:'MDL',
    UA:'UAH', RU:'RUB', TR:'TRY', GE:'GEL', AM:'AMD', AZ:'AZN', KZ:'KZT', UZ:'UZS',
    ZA:'ZAR', NA:'NAD', LS:'LSL', SZ:'SZL', BW:'BWP', ZM:'ZMW', ZW:'USD', MZ:'MZN', MW:'MWK', AO:'AOA',
    NG:'NGN', GH:'GHS', KE:'KES', UG:'UGX', TZ:'TZS', RW:'RWF', ET:'ETB', EG:'EGP', MA:'MAD', TN:'TND',
    DZ:'DZD', MU:'MUR', SC:'SCR', SN:'XOF', CI:'XOF', CM:'XAF',
    AE:'AED', SA:'SAR', QA:'QAR', KW:'KWD', BH:'BHD', OM:'OMR', JO:'JOD', IL:'ILS', LB:'LBP', IQ:'IQD',
    IN:'INR', PK:'PKR', BD:'BDT', LK:'LKR', NP:'NPR', MV:'MVR',
    CN:'CNY', HK:'HKD', MO:'MOP', TW:'TWD', JP:'JPY', KR:'KRW', MN:'MNT',
    SG:'SGD', MY:'MYR', TH:'THB', VN:'VND', ID:'IDR', PH:'PHP', KH:'KHR', LA:'LAK', MM:'MMK', BN:'BND',
    AU:'AUD', NZ:'NZD', FJ:'FJD', PG:'PGK', WS:'WST', TO:'TOP', PF:'XPF', NC:'XPF'
  };
  EURO.split(' ').forEach(function (c) { COUNTRY_CUR[c] = 'EUR'; });

  // Currencies offered in the panel: [code, flag country]
  var LIST = [
    ['USD','us'],['EUR','eu'],['GBP','gb'],['ZAR','za'],['AUD','au'],['CAD','ca'],['NZD','nz'],['JPY','jp'],
    ['CNY','cn'],['INR','in'],['SGD','sg'],['AED','ae'],['HKD','hk'],['KRW','kr'],['CHF','ch'],['SEK','se'],
    ['NOK','no'],['DKK','dk'],['PLN','pl'],['CZK','cz'],['HUF','hu'],['RON','ro'],['BGN','bg'],['ISK','is'],
    ['TRY','tr'],['UAH','ua'],['ILS','il'],['SAR','sa'],['QAR','qa'],['KWD','kw'],['BHD','bh'],['OMR','om'],
    ['JOD','jo'],['EGP','eg'],['NGN','ng'],['KES','ke'],['GHS','gh'],['MAD','ma'],['TND','tn'],['DZD','dz'],
    ['ETB','et'],['UGX','ug'],['TZS','tz'],['RWF','rw'],['ZMW','zm'],['BWP','bw'],['NAD','na'],['MUR','mu'],
    ['MZN','mz'],['AOA','ao'],['SCR','sc'],['XOF','sn'],['XAF','cm'],['MXN','mx'],['BRL','br'],['ARS','ar'],
    ['CLP','cl'],['COP','co'],['PEN','pe'],['UYU','uy'],['BOB','bo'],['PYG','py'],['CRC','cr'],['DOP','do'],
    ['GTQ','gt'],['JMD','jm'],['TTD','tt'],['PAB','pa'],['HNL','hn'],['BSD','bs'],['BBD','bb'],['KYD','ky'],
    ['THB','th'],['VND','vn'],['IDR','id'],['MYR','my'],['PHP','ph'],['PKR','pk'],['BDT','bd'],['LKR','lk'],
    ['NPR','np'],['KHR','kh'],['MMK','mm'],['MNT','mn'],['KZT','kz'],['UZS','uz'],['GEL','ge'],['AMD','am'],
    ['AZN','az'],['TWD','tw'],['MOP','mo'],['BND','bn'],['FJD','fj'],['PGK','pg'],['XPF','pf'],['RSD','rs'],
    ['MKD','mk'],['ALL','al'],['BAM','ba'],['MDL','md'],['MVR','mv'],['RUB','ru']
  ];
  var FLAG = {};
  LIST.forEach(function (p) { FLAG[p[0]] = p[1]; });

  var state = { currency: null, rates: null, ready: false, queue: [] };

  // ------------------------------------------------------------------ utils
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function isZero(c) { return !!ZERO_DEC[c]; }
  function isNative(c) { return Object.prototype.hasOwnProperty.call(MARKETS, c); }
  function flagUrl(c) { return 'https://flagcdn.com/w40/' + (FLAG[c] || String(c).slice(0, 2).toLowerCase()) + '.png'; }
  function escapeRe(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  var NAME_OVERRIDES = { USD: 'United States Dollar' };
  function currencyName(code) {
    if (NAME_OVERRIDES[code]) return NAME_OVERRIDES[code];
    try { return new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'currency' }).of(code); }
    catch (e) { return code; }
  }

  // ------------------------------------------------------------ detection
  function tzCurrency() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return (window.__cc_tzCurrency && window.__cc_tzCurrency(tz)) || null;
    } catch (e) { return null; }
  }

  function geoCurrency() {
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(new Error('timeout')); }, GEO_TIMEOUT);
      fetch('/browsing_context_suggestions.json?country[enabled]=true&currency[enabled]=true', {
        credentials: 'same-origin', headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          clearTimeout(t);
          var dv = d && d.detected_values;
          var country = dv && dv.country && (dv.country.handle || dv.country.iso_code);
          var cur = country && COUNTRY_CUR[String(country).toUpperCase()];
          if (cur) resolve(cur); else reject(new Error('unknown country'));
        })
        .catch(function (e) { clearTimeout(t); reject(e); });
    });
  }

  function detect() {
    var saved = lsGet(LS_CUR);
    if (saved) return Promise.resolve(saved.toUpperCase());
    return geoCurrency().catch(function () { return tzCurrency() || ACTIVE; });
  }

  // ---------------------------------------------------------------- rates
  var FALLBACK_RATES = { // USD value of 1 unit (same convention as Shopify's file)
    USD: 1, EUR: 1.08, GBP: 1.27, ZAR: 0.055, AUD: 0.66, CAD: 0.73, NZD: 0.6, JPY: 0.0067, CNY: 0.138,
    INR: 0.012, SGD: 0.74, AED: 0.2723, HKD: 0.128, CHF: 1.12, SEK: 0.095, NOK: 0.093, DKK: 0.145
  };

  function loadRates() {
    try {
      var c = JSON.parse(lsGet(LS_RATES) || 'null');
      if (c && c.rates && c.rates.USD && Date.now() - c.ts < RATES_TTL) return Promise.resolve(c.rates);
    } catch (e) {}
    return fetch('https://cdn.shopify.com/s/javascripts/currencies.js')
      .then(function (r) { return r.text(); })
      .then(function (src) {
        // eslint-disable-next-line no-new-func
        var C = new Function(src + '\n;return typeof Currency !== "undefined" ? Currency : null;')();
        if (!C || !C.rates || !C.rates.USD) throw new Error('bad rates file');
        lsSet(LS_RATES, JSON.stringify({ ts: Date.now(), rates: C.rates }));
        return C.rates;
      })
      .catch(function () { return FALLBACK_RATES; });
  }

  // ----------------------------------------------------------------- math
  function round99(amount, code) {
    if (isZero(code)) return Math.round(amount);
    return Math.floor(amount) + 0.99;
  }

  // convert(cents, { from, to, fromUSD, round })
  //   -> { cents, exactCents, currency, native }
  //   cents      = display value (.99 rule) unless round:false or same currency
  //   exactCents = unrounded value
  function convert(cents, opts) {
    opts = opts || {};
    var from = String(opts.fromUSD ? 'USD' : (opts.from || ACTIVE)).toUpperCase();
    var to = String(opts.to || state.currency || ACTIVE).toUpperCase();
    var major = isZero(from) ? cents : cents / 100;
    var toMinor = function (v) { return isZero(to) ? Math.round(v) : Math.round(v * 100); };

    if (from === to) return { cents: cents, exactCents: cents, currency: to, native: isNative(to) };

    var r = state.rates || FALLBACK_RATES;
    if (!r[from] || !r[to]) return { cents: cents, exactCents: cents, currency: from, native: isNative(from), failed: true };

    var value = major * r[from] / r[to];
    var shown = opts.round === false ? value : round99(value, to);
    return { cents: toMinor(shown), exactCents: toMinor(value), currency: to, native: isNative(to) };
  }

  // Store-currency amounts use the store's own money format ("R 2,466.99"),
  // other currencies use Intl ("$149.99", "€138.99", "¥22,500").
  var STORE_FMT = (function () {
    var s = SAMPLE.plain || 'R 1,234.56';
    var i = s.indexOf('1'), j = s.lastIndexOf('6');
    var num = s.slice(i, j + 1);
    var th = num.match(/1(\D)234/), dc = num.match(/4(\D)56/);
    return { prefix: s.slice(0, i), suffix: s.slice(j + 1), thousands: th ? th[1] : '', decimal: dc ? dc[1] : '.' };
  })();

  function format(cents, code) {
    code = String(code || state.currency || ACTIVE).toUpperCase();
    var amount = isZero(code) ? cents : cents / 100;
    if (code === ACTIVE) {
      var fixed = amount.toFixed(isZero(code) ? 0 : 2).split('.');
      var intPart = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, STORE_FMT.thousands);
      return STORE_FMT.prefix + intPart + (fixed[1] ? STORE_FMT.decimal + fixed[1] : '') + STORE_FMT.suffix;
    }
    try {
      return amount.toLocaleString('en', {
        style: 'currency', currency: code,
        minimumFractionDigits: isZero(code) ? 0 : 2, maximumFractionDigits: isZero(code) ? 0 : 2
      });
    } catch (e) { return code + ' ' + amount.toFixed(isZero(code) ? 0 : 2); }
  }

  // --------------------------------------------------------- page walker
  // Only real store-formatted money: "R 1,234.56" (+ optional " ZAR") or "ZAR 1,234.56".
  // The symbol must not be glued to a preceding letter/digit, so "OVER 175" never matches.
  var MONEY_RE = (function () {
    var sym = STORE_FMT.prefix.trim() || 'R';
    var t = escapeRe(STORE_FMT.thousands || ',');
    var d = escapeRe(STORE_FMT.decimal || '.');
    var num = '(\\d{1,3}(?:' + t + '\\d{3})+(?:' + d + '\\d{1,2})?|\\d+(?:' + d + '\\d{1,2})?)';
    var code = escapeRe(ACTIVE);
    var ws = '[\\s\\u00a0]?';
    return new RegExp(
      '(^|[^A-Za-z0-9])(?:' + escapeRe(sym) + ws + num + '(?:' + ws + code + ')?|' + code + ws + num + ')(?!\\d)',
      'g'
    );
  })();

  function parseNum(s) {
    if (STORE_FMT.thousands) s = s.split(STORE_FMT.thousands).join('');
    if (STORE_FMT.decimal && STORE_FMT.decimal !== '.') s = s.replace(STORE_FMT.decimal, '.');
    return parseFloat(s);
  }

  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, TEMPLATE: 1 };
  var tracked = new Set();          // text nodes we have rewritten
  var info = new WeakMap();         // node -> { orig, out }

  function skipNode(node) {
    var el = node.parentElement;
    if (!el || SKIP[el.tagName]) return true;
    return !!el.closest('[data-cc-ignore], [contenteditable="true"]');
  }

  function processText(node) {
    var v = node.nodeValue;
    if (v == null) return;
    var rec = info.get(node);
    if (rec && v === rec.out) v = rec.orig;   // ours - re-render from original
    else if (rec) rec = null;                 // theme rewrote it - fresh original

    var viewing = state.currency || ACTIVE;
    if (viewing === ACTIVE) {
      if (rec && node.nodeValue !== rec.orig) node.nodeValue = rec.orig;
      info.delete(node); tracked.delete(node);
      return;
    }
    if (!/\d/.test(v) || skipNode(node)) return;
    MONEY_RE.lastIndex = 0;
    if (!MONEY_RE.test(v)) return;
    MONEY_RE.lastIndex = 0;
    var out = v.replace(MONEY_RE, function (full, lead, n1, n2) {
      var n = parseNum(n1 || n2);
      if (!isFinite(n)) return full;
      var cents = isZero(ACTIVE) ? Math.round(n) : Math.round(n * 100);
      var res = convert(cents, { from: ACTIVE, to: viewing });
      return res.failed ? full : lead + format(res.cents, viewing);
    });
    info.set(node, { orig: v, out: out });
    tracked.add(node);
    if (node.nodeValue !== out) node.nodeValue = out;
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { processText(root); return; }
    if (root.nodeType !== 1 || SKIP[root.tagName]) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(processText);
  }

  function refreshPage() {
    tracked.forEach(function (n) { if (!n.isConnected) tracked.delete(n); });
    Array.from(tracked).forEach(processText);                 // restore / re-render
    if ((state.currency || ACTIVE) !== ACTIVE) walk(document.body);
  }

  // Batch DOM mutations (Dawn re-renders cart/variant HTML a lot)
  var pending = [], scheduled = false;
  function flush() {
    scheduled = false;
    var nodes = pending; pending = [];
    var cartTouched = false;
    nodes.forEach(function (n) {
      if (n.nodeType === 1 && (n.matches('[data-cc-shipbar], [data-cc-cart-note]') ||
          n.querySelector('[data-cc-shipbar], [data-cc-cart-note]'))) cartTouched = true;
      if ((state.currency || ACTIVE) !== ACTIVE && n.isConnected) walk(n);
    });
    if (cartTouched && state.ready) refreshCartUi();
  }
  function startObserver() {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'characterData') pending.push(m.target);
        else m.addedNodes.forEach(function (n) { pending.push(n); });
      });
      if (!scheduled) { scheduled = true; setTimeout(flush, 0); }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  // ------------------------------------------------ cart note + ship bar
  var cartReq = null;
  function getCart() {
    if (!cartReq) {
      cartReq = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      cartReq.then(clear, clear);
    }
    function clear() { setTimeout(function () { cartReq = null; }, 0); }
    return cartReq;
  }

  function refreshCartUi() {
    var notes = document.querySelectorAll('[data-cc-cart-note]');
    var bars = document.querySelectorAll('[data-cc-shipbar]');
    if (!notes.length && !bars.length) return;
    getCart().then(function (cart) {
      var viewing = state.currency || ACTIVE;

      notes.forEach(function (note) {
        // exactly one note per checkout area
        var parent = note.parentElement;
        if (parent) {
          var dupes = parent.querySelectorAll(':scope > [data-cc-cart-note]');
          for (var i = 1; i < dupes.length; i++) dupes[i].remove();
        }
        if (!note.isConnected) return;
        if (viewing === ACTIVE || !cart.item_count) { note.hidden = true; return; }
        var conv = convert(cart.total_price, { from: ACTIVE, to: viewing });
        note.querySelector('[data-cc-currency-code]').textContent = viewing;
        note.querySelector('[data-cc-converted-total]').textContent = format(conv.cents, viewing);
        note.querySelector('[data-cc-charge-total]').textContent = format(cart.total_price, ACTIVE); // exact
        note.querySelector('[data-cc-charge-currency]').textContent = ACTIVE;
        note.hidden = false;
      });

      bars.forEach(function (bar) {
        var usd = parseInt(bar.getAttribute('data-cc-threshold-usd-cents'), 10);
        if (!usd) return;
        var eligible = 0;
        (cart.items || []).forEach(function (it) {
          if (!/shipping\s*protection|warranty|insurance/i.test(it.product_title || it.title || '')) eligible += it.final_line_price;
        });
        var target = convert(usd, { fromUSD: true, to: ACTIVE }).exactCents;  // real trigger (checkout currency)
        var shown = convert(usd, { fromUSD: true, to: viewing });              // display (.99)
        var done = cart.item_count > 0 && eligible >= target;
        var pct = target > 0 ? Math.min(100, Math.round(eligible / target * 100)) : 0;
        var banner = bar.hasAttribute('data-t2k-banner');

        var msg = bar.querySelector('[data-t2k-shipbar-msg]');
        var fill = bar.querySelector('[data-t2k-shipbar-fill]');
        bar.classList.toggle('is-complete', done);
        if (fill) {
          fill.style.width = (done ? 100 : pct) + '%';
          if (!done && pct > 0 && pct < 30) fill.setAttribute('data-low', 'true'); else fill.removeAttribute('data-low');
        }
        if (msg) {
          if (!cart.item_count) {
            msg.innerHTML = banner
              ? '<span aria-hidden="true">✦</span> FREE WORLDWIDE SHIPPING ON ORDERS OVER <strong>' + format(shown.cents, viewing) + '</strong>'
              : 'Free shipping on orders over <strong>' + format(shown.cents, viewing) + '</strong>';
          } else if (done) {
            msg.innerHTML = '<strong>✓ You unlocked free shipping</strong>';
          } else {
            var rem = convert(target - eligible, { from: ACTIVE, to: viewing });
            msg.innerHTML = "You're <strong>" + format(rem.cents, viewing) + '</strong> away from ' +
              (banner ? 'FREE SHIPPING' : 'free shipping');
          }
        }
        bar.setAttribute('data-cc-done', '');
      });
    }).catch(function () {
      bars.forEach(function (b) { b.setAttribute('data-cc-done', ''); });
    });
  }

  // --------------------------------------------------------- public API
  function markReady() {
    document.documentElement.classList.remove('cc-pending');
    window.__cc_ready = true;
    if (!state.ready) {
      state.ready = true;
      state.queue.splice(0).forEach(function (cb) { try { cb(); } catch (e) {} });
    }
  }

  function submitLocalization(country) {
    var f = document.createElement('form');
    f.method = 'post'; f.action = '/localization'; f.style.display = 'none';
    [['_method', 'PUT'], ['country_code', country], ['return_to', location.pathname + location.search]].forEach(function (p) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = p[0]; i.value = p[1]; f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
  }

  var API = {
    ready: function (cb) { if (state.ready) cb(); else state.queue.push(cb); },
    get: function () { return state.currency || ACTIVE; },
    rates: function () { return state.rates; },
    convert: convert,
    format: format,
    set: function (code) {
      code = String(code).toUpperCase();
      lsSet(LS_CUR, code);
      // A currency Shopify Markets really checks out in -> switch the real market (checkout charges in it).
      if (isNative(code) && code !== ACTIVE) { submitLocalization(MARKETS[code]); return; }
      state.currency = code;
      refreshPage();
      refreshCartUi();
      document.dispatchEvent(new CustomEvent('currency:change', { detail: { currency: code } }));
    },
    open: function () { document.dispatchEvent(new CustomEvent('currency-panel:open')); }
  };
  window.CurrencyConverter = API;

  // ------------------------------------------------------------- panel
  function initPanel() {
    var root = document.querySelector('[data-cc-widget-root]');
    if (!root) return;
    var trigger = root.querySelector('[data-cc-trigger]');
    var panel = root.querySelector('[data-cc-panel]');
    var search = root.querySelector('[data-cc-search]');
    var list = root.querySelector('[data-cc-list]');

    function entries() {
      var r = state.rates || FALLBACK_RATES;
      var sugg = [];
      [state.currency, 'USD', ACTIVE].concat(Object.keys(MARKETS)).forEach(function (c) {
        if (c && sugg.indexOf(c) < 0 && r[c]) sugg.push(c);
      });
      var named = function (c) { return { code: c, name: currencyName(c) }; };
      var all = LIST.map(function (p) { return p[0]; }).filter(function (c) { return r[c]; });
      return {
        suggested: sugg.map(named),
        all: all.map(named).sort(function (a, b) { return a.name.localeCompare(b.name); })
      };
    }

    function render(q) {
      q = (q || '').trim().toLowerCase();
      var e = entries();
      var cur = state.currency || ACTIVE;
      var ok = function (x) { return !q || x.code.toLowerCase().indexOf(q) > -1 || x.name.toLowerCase().indexOf(q) > -1; };
      var group = function (label, items) {
        items = items.filter(ok);
        if (!items.length) return '';
        return '<li class="cc-group" role="presentation">' + label + '</li>' + items.map(function (x) {
          return '<li role="option" tabindex="-1" class="cc-opt' + (x.code === cur ? ' is-current' : '') +
            '" aria-selected="' + (x.code === cur) + '" data-cc-option="' + x.code + '">' +
            '<img src="' + flagUrl(x.code) + '" alt="" width="20" height="15" loading="lazy">' +
            '<span class="cc-opt__name">' + x.name + '</span><span class="cc-opt__code">' + x.code + '</span></li>';
        }).join('');
      };
      list.innerHTML = (group('Suggested', e.suggested) + group('All currencies', e.all)) ||
        '<li class="cc-empty">No currencies found</li>';
    }

    function updateTrigger() {
      var c = state.currency || ACTIVE;
      root.querySelector('[data-cc-trigger-code]').textContent = c;
      var img = root.querySelector('[data-cc-trigger-flag]');
      img.src = flagUrl(c);
      img.hidden = false;
      root.classList.add('is-ready');
    }

    function open() {
      render('');
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      search.value = '';
      setTimeout(function () { search.focus(); }, 30);
    }
    function close() {
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }
    function choose(code) { close(); API.set(code); updateTrigger(); }

    trigger.addEventListener('click', function () { if (root.classList.contains('is-open')) close(); else open(); });
    root.querySelectorAll('[data-cc-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('currency-panel:open', open);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) { close(); trigger.focus(); }
    });
    search.addEventListener('input', function () { render(search.value); });
    search.addEventListener('keydown', function (e) {
      var first = list.querySelector('[data-cc-option]');
      if (e.key === 'ArrowDown' && first) { e.preventDefault(); first.focus(); }
      if (e.key === 'Enter' && first) { e.preventDefault(); choose(first.getAttribute('data-cc-option')); }
    });
    list.addEventListener('click', function (e) {
      var o = e.target.closest('[data-cc-option]');
      if (o) choose(o.getAttribute('data-cc-option'));
    });
    list.addEventListener('keydown', function (e) {
      var o = e.target.closest('[data-cc-option]');
      if (!o) return;
      var step = function (dir) {
        var n = o[dir];
        while (n && !n.hasAttribute('data-cc-option')) n = n[dir];
        return n;
      };
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(o.getAttribute('data-cc-option')); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); var d = step('nextElementSibling'); if (d) d.focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); var u = step('previousElementSibling'); (u || search).focus(); }
    });

    API.ready(updateTrigger);
  }

  // Dawn's subscribe/PUB_SUB_EVENTS come from deferred pubsub.js + constants.js:
  // hooked after DOMContentLoaded, never at top-level scope.
  function hookDawn() {
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshCartUi, 50); });
    }
  }

  // Cart AJAX (add/change/update/clear) from any script -> refresh note + bar
  (function hookFetch() {
    var orig = window.fetch;
    window.fetch = function (input) {
      var p = orig.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(refreshCartUi, 150); }, function () {});
      } catch (e) {}
      return p;
    };
  })();

  // --------------------------------------------------------------- init
  function init() {
    initPanel();
    hookDawn();
    startObserver();
    Promise.all([detect(), loadRates()]).then(function (res) {
      state.rates = res[1];
      state.currency = res[1][res[0]] ? res[0] : ACTIVE;
      refreshPage();
      markReady();
      refreshCartUi();
      if (state.currency !== ACTIVE) {
        document.dispatchEvent(new CustomEvent('currency:change', { detail: { currency: state.currency } }));
      }
    }).catch(function () {
      state.currency = ACTIVE;
      markReady();
      refreshCartUi();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(window, document);
